import logger from "../../../util/logger";
import * as _ from "../../../util/lodash";
import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
import cx from 'classnames';
import { whitelistStyles } from "../../core/hoc";
import Icon from "../../core/icon";
import Header from "../../core/header";
import TabMenu from "../../core/tab-menu";
import { colors, sizes, textAlignments, font } from "../../../enums";
var BaseToolbar = createComponent({
  displayName: 'BaseToolbar',
  propTypes: {
    actions: PropTypes.element,
    areActionsDivided: PropTypes.bool,
    hasBorder: PropTypes.bool,
    header: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    icon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    isIconDivided: PropTypes.bool,
    onClose: PropTypes.func,
    tabMenu: PropTypes.oneOfType([PropTypes.element, PropTypes.shape({
      items: PropTypes.array,
      onClick: PropTypes.func,
      activeValue: PropTypes.bool
    })]),
    textAlign: PropTypes.oneOf(textAlignments.ALL),
    toolbarType: PropTypes.string
  },
  defaultProps: {
    actions: null,
    areActionsDivided: false,
    hasBorder: false,
    header: undefined,
    icon: undefined,
    isIconDivided: false,
    onClose: _.noop,
    tabMenu: undefined,
    textAlign: textAlignments.LEFT,
    toolbarType: undefined
  },
  contextTypes: {
    isInverted: PropTypes.bool
  },
  render: function render(props) {
    var _cx;

    var wrapperClassnames = cx('ck', 'base-toolbar', (_cx = {
      bordered: props.hasBorder,
      inverted: props.isInverted
    }, _cx[props.toolbarType + "-toolbar"] = !!props.toolbarType, _cx));
    logger.warn('Prop `icon` must be a string for simple toolbars', props.toolbarType === 'simple' && !!props.icon && typeof props.icon !== 'string');
    return /*#__PURE__*/React.createElement("div", {
      className: wrapperClassnames,
      style: props.style
    }, /*#__PURE__*/React.createElement(BaseToolbarIcon, {
      icon: props.icon,
      isIconDivided: props.isIconDivided
    }), /*#__PURE__*/React.createElement(BaseToolbarTabMenu, {
      tabMenu: props.tabMenu
    }), /*#__PURE__*/React.createElement(BaseToolbarHeader, {
      header: props.header,
      textAlign: props.textAlign
    }), /*#__PURE__*/React.createElement(BaseToolbarActions, {
      actions: props.actions,
      areActionsDivided: props.areActionsDivided
    }));
  }
});

var BaseToolbarHeader = function BaseToolbarHeader(_ref) {
  var header = _ref.header,
      textAlign = _ref.textAlign;
  return /*#__PURE__*/React.createElement("div", {
    className: "toolbar__header"
  }, /*#__PURE__*/React.isValidElement(header) ? header : /*#__PURE__*/React.createElement(Header, {
    text: header,
    textAlign: textAlign,
    font: {
      weight: font.weights.LIGHT,
      family: font.families.CUSTOM,
      emphasis: font.emphasis.NORMAL
    }
  }));
};

var BaseToolbarActions = function BaseToolbarActions(_ref2) {
  var actions = _ref2.actions,
      areActionsDivided = _ref2.areActionsDivided;

  var _actionsCls = cx('toolbar__actions', {
    divided: areActionsDivided
  });

  return actions ? /*#__PURE__*/React.createElement("div", {
    className: _actionsCls
  }, actions) : null;
};

var BaseToolbarIcon = function BaseToolbarIcon(_ref3) {
  var icon = _ref3.icon,
      isIconDivided = _ref3.isIconDivided;

  var _cls = cx('toolbar__icon', {
    divided: isIconDivided
  });

  return icon ? /*#__PURE__*/React.createElement("div", {
    className: _cls
  }, /*#__PURE__*/React.isValidElement(icon) ? icon : /*#__PURE__*/React.createElement(Icon, {
    name: icon,
    color: colors.ACCENT,
    size: sizes.X7
  })) : null;
};

var BaseToolbarTabMenu = function BaseToolbarTabMenu(_ref4) {
  var tabMenu = _ref4.tabMenu;
  return tabMenu ? /*#__PURE__*/React.createElement("div", {
    className: "toolbar__tab-menu"
  }, /*#__PURE__*/React.isValidElement(tabMenu) ? tabMenu : /*#__PURE__*/React.createElement(TabMenu, {
    items: tabMenu.items ? tabMenu.items : [],
    activeValue: tabMenu.activeValue,
    onItemClick: tabMenu.onClick,
    isVertical: false
  })) : null;
};

export default whitelistStyles()(BaseToolbar);
//# sourceMappingURL=base-toolbar.js.map